exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".col-sm-2[_v-31d32128]{padding:0;margin-right:15px}i[_v-31d32128]{color:#d8d8d8;font-size:20px;padding:5px}@media (max-width:768px){.col-sm-2[_v-31d32128]{padding-left:15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-31d32128&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=1!./src/components/Admin/Admin-product-general.vue
// module id = 417
// module chunks = 0